import Flex from '@Components/Bases/Flex';
import { Box, Typography } from '@mui/material';
import GreenhouseStrategyPlanForm from './GreenhouseStrategyPlanForm';
import GreenhouseStrategyPlanRemark, {
  GH_STRATEGY_PLAN_REMARK_ID,
} from './GreenhouseStrategyPlanRemark';

const GreenhouseStrategyPlan = () => {
  return (
    <Box>
      <Flex gap={1} alignItems={'center'} mt={2}>
        <Typography fontWeight={'bold'}>แผนการจัดการก๊าซเรือนกระจก</Typography>
        <GreenhouseStrategyPlanRemark />
      </Flex>
      <GreenhouseStrategyPlanForm />
      <Box id={GH_STRATEGY_PLAN_REMARK_ID} />
    </Box>
  );
};

export default GreenhouseStrategyPlan;
